import { render, staticRenderFns } from "./ClipboardLink.vue?vue&type=template&id=7671534e&v-if=loaded&"
import script from "./ClipboardLink.vue?vue&type=script&lang=js&"
export * from "./ClipboardLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports